import toast from 'react-hot-toast';
import { exportToCSV, exportToExcel, triggerFileInput, importFromFile } from '../../shared/utils/importExportUtils';
import { formatBankingExportRows } from './bankingHelpers';

export async function exportBankingRows(data, headers, prefix, format) {
  if (!data?.length) {
    toast.error('لا توجد بيانات للتصدير');
    return false;
  }
  const rows = formatBankingExportRows(data);
  const filename = `${prefix}_${new Date().toISOString().split('T')[0]}`;
  if (format === 'excel') {
    await exportToExcel(rows, headers, `${filename}.xlsx`);
  } else {
    exportToCSV(rows, headers, `${filename}.csv`);
  }
  return true;
}

export function importBankingRows({ headers, schema, mapRow, postRow, onComplete, accept = '.csv,.xlsx,.xls' }) {
  triggerFileInput(async (file) => {
    try {
      const result = await importFromFile(file, headers, schema);
      if (!result.success) return;

      let successCount = 0;
      for (const record of result.data) {
        try {
          await postRow(mapRow(record));
          successCount += 1;
        } catch (err) {
          console.error('Import record error:', err);
        }
      }

      if (onComplete) await onComplete();
      toast.success(`تم استيراد ${successCount}/${result.totalCount} سجل`);
    } catch (error) {
      console.error('Import error:', error);
      toast.error(error.message || 'خطأ أثناء الاستيراد');
    }
  }, accept);
}

export function exportBankingPdf(title) {
  toast.success(`${title} — استخدم طباعة المتصفح (Ctrl+P)`);
  window.print();
}
